import React, { ReactNode } from 'react';
import {
  useAddToFavoriteMutation,
  useDeleteFavoriteMutation,
  useFavoriteProductIds,
} from './useFavoriteProducts';
import { favoriteProductsContext } from './favorite-product-context';

type Props = {
  children: ReactNode;
};

export function FavoriteProductsProvider(props: Props) {
  const { children } = props;
  const { data: favoriteProducts } = useFavoriteProductIds();
  const productIds = favoriteProducts?.productIds || [];

  const addToFavoriteMutation = useAddToFavoriteMutation();
  const removeToFavoriteMutation = useDeleteFavoriteMutation();

  const modifyFavoriteProducts = (sku: string) => {
    let isAddedToFavorite = -1;
    if (productIds) {
      isAddedToFavorite = productIds?.indexOf(sku);
    }
    if (isAddedToFavorite > -1) {
      removeToFavoriteMutation.mutate(sku);
    } else {
      addToFavoriteMutation.mutate(sku);
    }
  };

  const { Provider } = favoriteProductsContext;

  return (
    <Provider value={{ modifyFavoriteProducts, productIds }}>
      {children}
    </Provider>
  );
}
